var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1351.08 658.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#686b6b;}.cls-2{fill:#4f5151;}.cls-3{fill:#24313f;}.cls-4{fill:#1d5c96;}.cls-5{fill:#384449;}.cls-6{fill:#283237;}.cls-7{fill:#d0d0d0;}.cls-8{fill:#c1e9f7;}.cls-9{fill:#214471;}.cls-10{fill:#e6f9ff;}.cls-11{fill:#a74541;}.cls-12{fill:#414242;}.cls-13{fill:#fff;}.cls-14{fill:#b0affd;opacity:0.2;}.cls-15{fill:none;stroke:#d6d7d8;stroke-miterlimit:10;stroke-width:2px;}.cls-16{fill:#353535;}.cls-17{fill:#464747;}.cls-18{fill:#1b5987;}.cls-19{fill:#53b3e1;}.cls-20{fill:#c2e1ee;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CARRO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1213.65,257.55V305a26.57,26.57,0,0,1-26.58,26.58h-8.51A26.67,26.67,0,0,1,1152,305V257.55a26.2,26.2,0,0,1,3.86-13.65v-.07A26.67,26.67,0,0,1,1178.56,231h8.51A26.68,26.68,0,0,1,1213.65,257.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1210.86,316.86a26.65,26.65,0,0,1-23.79,14.72h-8.51A26.67,26.67,0,0,1,1152,305V257.55a26.2,26.2,0,0,1,3.86-13.65C1156.34,246.83,1167.63,311.93,1210.86,316.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "792.23 604.83 923.63 604.83 923.63 472.21 786.55 472.21 792.23 604.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1206.56,324.5,561,340.42V0H984.92a107.7,107.7,0,0,1,95.85,58.59l27.74,54.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M839.83,583.26c0,36,18.57,75.7,18.57,75.7h31.43c27.62,0,50-33.89,50-75.7S886,507.55,858.4,507.55,839.83,541.44,839.83,583.26Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 858.4,
    cy: 583.26,
    rx: 50.01,
    ry: 75.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M821.36,583.26c0,31.49,16.86,57,37.67,57s37.66-25.53,37.66-57-16.86-57-37.66-57S821.36,551.76,821.36,583.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1201.28,583.26c0,36,18.57,75.7,18.57,75.7h31.44c27.61,0,50-33.89,50-75.7s-53.82-75.71-81.44-75.71S1201.28,541.44,1201.28,583.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1169.85,583.26c0,41.81,22.38,75.7,50,75.7s50-33.89,50-75.7-22.39-75.71-50-75.71S1169.85,541.44,1169.85,583.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1182.81,583.26c0,31.49,16.87,57,37.67,57s37.67-25.53,37.67-57-16.87-57-37.67-57S1182.81,551.76,1182.81,583.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M371.23,583.26c0,36,18.58,75.7,18.58,75.7h31.43c27.62,0,50-33.89,50-75.7s-53.83-75.71-81.44-75.71S371.23,541.44,371.23,583.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.8,583.26c0,41.81,22.39,75.7,50,75.7s50-33.89,50-75.7-22.39-75.71-50-75.71S339.8,541.44,339.8,583.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M352.77,583.26c0,31.49,16.86,57,37.66,57s37.67-25.53,37.67-57-16.86-57-37.67-57S352.77,551.76,352.77,583.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1351.08,547.52a57.17,57.17,0,0,1-57.16,57.31H923.63a113.5,113.5,0,0,0,1.64-19.29c0-48.95-29.37-88.68-65.52-88.68s-65.6,39.73-65.6,88.68a113.55,113.55,0,0,0,1.57,19.29H579.35s-8.72-96.61-7.65-145.06c.86-42.15.86-124.76-1.64-144.91,0-3,208.65-3.36,261.32-3.57,7.14-.07,11.43-.07,11.86-.07l.71.5.79.57c9.72,6.79,64.17,44.95,98,67.31,29.8,19.65,249.74,27.66,336,30.09,21.43.57,34.65.78,34.65.78a156,156,0,0,1,22.23,31.16c8,14.79,15.15,33.79,15.29,54.59.07,12.93.14,28.51.14,43.8C1351.08,542.52,1351.08,545,1351.08,547.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1154.51,311.22H864.39a17.15,17.15,0,0,1-15.58-10L777,141.44a7.92,7.92,0,0,1,7.22-11.15h306a17,17,0,0,1,15.58,10.22l51.45,117.54,12.86,29.37A17,17,0,0,1,1154.51,311.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1019.38,540c-.07,5-.28,9.72-.57,13.94-2.07,27.79-30,50.87-30,50.87H923.63A115.61,115.61,0,0,0,916,540c-11.5-25.87-32.37-43.16-56.23-43.16S814.94,514.15,803.44,540a117.06,117.06,0,0,0-7.72,64.81H561V0H749.42V120.07s56.52,132.77,82,191.22c6.29,14.57,10.72,24.51,11.86,26.65,5.65,10.79,137,77.25,158.7,96.83C1014,445.63,1020,502.08,1019.38,540Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M751.52,159l61.8,152.21h-106s-21.76-3.64-24.54-48.09c-3-47.46-3-129.35-3-129.35l46.55-.23C744.06,136.25,746.84,146,751.52,159Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1313.36 410.47 969.5 410.47 843.95 311.72 843.24 311.22 1190.09 311.22 1288.85 390.68 1313.36 410.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1335.58,441.63c-2,3.28-4.57,5.43-7.36,5.93L1280,456.49c-4.07.79-7.21-6.29-6.14-13.58l4.72-32.44.14-.78.93-6.65c.85-5.72,3.35-10.08,6.43-11.29l2.79-1.07,24.5,19.79A156,156,0,0,1,1335.58,441.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1014,468.5l-31.08-3.08a24.35,24.35,0,0,1-21.58-19.94l-7.15-39.3a5.52,5.52,0,0,1-.14-1.85c22.15,12.71,40.8,24.08,47.87,30.44C1007.09,439.41,1011.16,452.27,1014,468.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1073,474.35l-58.95-5.85H1014l-31.08-3.08a24.35,24.35,0,0,1-21.58-19.94l-7.15-39.3a5.52,5.52,0,0,1-.14-1.85v-.08A13.08,13.08,0,0,1,969.79,391l91.82,18.65a15.84,15.84,0,0,1,12.08,11.29l10.79,39.88A10.75,10.75,0,0,1,1073,474.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1108.53,112.73H750.32a207.36,207.36,0,0,0-10.38-49.1c-8-23.12-21.83-48.9-46-63.62H986.62c47.72,0,90,25.49,106.8,63.62a48.68,48.68,0,0,1,2.07,4.74A298.32,298.32,0,0,1,1108.53,112.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1014.09,468.5l-31.15-3.08a24.35,24.35,0,0,1-21.58-19.94l-7.15-39.3a6,6,0,0,1-.14-1.93c22.15,12.79,40.8,24.16,47.87,30.52C1007.09,439.41,1011.16,452.27,1014.09,468.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1351.08,547.52c.08,31.66-26.79,57.31-59.95,57.31H923.63A115.61,115.61,0,0,0,916,540h435C1351.08,542.52,1351.08,545,1351.08,547.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M794.15,585.54a113.55,113.55,0,0,0,1.57,19.29H561V540H803.44A113.25,113.25,0,0,0,794.15,585.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M627.32,540v64.86H38.63A38.64,38.64,0,0,1,0,566.24V540Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1109,413.27H1249.6c4.5,0,7.93,6.05,7.24,12.77l-5,48.86c-.73,7.19-4.82,12.49-9.63,12.49H1126.38c-7.43,0-14-7.35-16.15-18.1l-8.34-41.54C1100.44,420.54,1104,413.27,1109,413.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1157.29,258.05c-165.85-8.5-278-97.25-311.91-127.76h244.88a17,17,0,0,1,15.58,10.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M627.32,0V540H0V75A75,75,0,0,1,75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M627.32,0V540H0V75A75,75,0,0,1,75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M606.79,56.42V522.35H20.53V87.8A70.13,70.13,0,0,1,90.66,17.67H568A38.75,38.75,0,0,1,606.79,56.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M781.87,233.09s5.37,61.51-25,78.36H813.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M790.21,274.26s-12.82-9.12-13.91-16.68v43h16.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M776.28,257.55V305a26.55,26.55,0,0,1-26.58,26.58h-8.5A26.66,26.66,0,0,1,714.62,305V257.55a26.11,26.11,0,0,1,3.86-13.65v-.07A26.65,26.65,0,0,1,741.2,231h8.5A26.67,26.67,0,0,1,776.28,257.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M773.5,316.86a26.67,26.67,0,0,1-23.8,14.72h-8.5A26.66,26.66,0,0,1,714.62,305V257.55a26.11,26.11,0,0,1,3.86-13.65C719,246.83,730.27,311.93,773.5,316.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M204.89,604.88H50.58C47.32,591,37.5,491.76,124,491.76,202.57,491.76,208.35,582.25,204.89,604.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.88,583.26c0,36,18.57,75.7,18.57,75.7h31.44c27.62,0,50-33.89,50-75.7s-53.83-75.71-81.45-75.71S98.88,541.44,98.88,583.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M67.45,583.26c0,41.81,22.39,75.7,50,75.7s50-33.89,50-75.7-22.39-75.71-50-75.71S67.45,541.44,67.45,583.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M80.42,583.26c0,31.49,16.86,57,37.66,57s37.67-25.53,37.67-57-16.86-57-37.67-57S80.42,551.76,80.42,583.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1108.53,112.73H750.32a207.36,207.36,0,0,0-10.38-49.1h353.48a48.68,48.68,0,0,1,2.07,4.74A298.32,298.32,0,0,1,1108.53,112.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M376.71,250.18c7.87-23.79-8.53-69.89-80.68-62.5,116.92-50.83,120.91,24.53,80.68,62.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M247.74,224.76c-7.87,23.79,8.53,69.89,80.68,62.5-116.92,50.83-120.91-24.52-80.68-62.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "238.66 215.42 234.36 215.42 234.36 216.13 231.08 216.13 231.08 214.4 228.09 214.4 228.09 219.14 228.51 219.14 228.51 219.86 231.5 219.86 231.5 219.14 234.79 219.14 234.79 218.08 238.66 218.08 238.66 215.42"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 235.56,
    y: 205.74,
    width: 2.99,
    height: 2.99
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "234.13 206.28 231.14 206.28 231.14 208.55 228.79 208.55 228.79 210.68 232.52 210.68 232.52 209.26 234.13 209.26 234.13 206.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "224.69 219.95 224.69 217.45 220.75 217.45 220.75 218.47 220.75 219.95 220.75 220.2 218.18 220.2 218.18 222.69 220.93 222.69 220.93 225.16 223.97 225.16 223.97 222.11 222.94 222.11 222.94 219.95 224.69 219.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "220.22 234.7 218.57 234.7 217.37 234.7 217.05 234.7 217.05 232.49 218.03 232.49 218.03 230.72 216.11 230.72 212.74 230.72 210.17 230.72 210.17 233.76 215.07 233.76 215.07 238.59 215.72 238.59 217.05 238.59 218.57 238.59 218.57 236.93 220.22 236.93 220.22 234.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 221.64,
    y: 232.39,
    width: 2.87,
    height: 2.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 208.79,
    y: 241.23,
    width: 3.03,
    height: 3.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "216.24 248.22 214.39 248.22 213.22 248.22 211.37 248.22 211.37 252.88 214.39 252.88 214.39 251.16 216.24 251.16 216.24 248.22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 202.12,
    y: 244.04,
    width: 4.62,
    height: 4.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "201.92 260.65 201.92 257.72 198.84 257.72 198.84 262.34 200.75 262.34 200.75 264.55 203.83 264.55 203.83 260.65 201.92 260.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 204.22,
    y: 276.37,
    width: 3.08,
    height: 4.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "204.37 283.67 204.37 281.33 201.29 281.33 201.29 286.01 203.32 286.01 204.37 286.01 206.4 286.01 206.4 283.67 204.37 283.67"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 203.8,
    y: 251.03,
    width: 2.88,
    height: 2.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 206.84,
    y: 266.03,
    width: 4.48,
    height: 2.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 208.1,
    y: 283.24,
    width: 4.05,
    height: 5.51
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "204.23 269.97 201.05 269.97 201.05 271.94 197.11 271.94 197.11 277.44 201.49 277.44 201.49 275.48 204.23 275.48 204.23 269.97"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 206.43,
    y: 255.45,
    width: 3.06,
    height: 4.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "202.46 289.62 202.46 287 198.28 287 198.28 291.18 201.39 291.18 201.39 293.34 205.22 293.34 205.22 295.84 208.4 295.84 208.4 293.34 208.4 292.13 208.4 289.62 202.46 289.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "225.65 314.31 225.65 311.79 225.65 310.24 222.85 310.24 222.85 310.18 222.85 309.13 222.85 307.88 218.61 307.88 218.61 310.18 219.82 310.18 219.82 315.35 221.91 315.35 222.72 315.35 222.72 316.9 223.38 316.9 225.65 316.9 228.94 316.9 228.94 314.31 225.65 314.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "242.59 314.11 242.59 309.19 236.44 309.19 236.44 310.85 230.61 310.85 230.61 318.79 231.8 318.79 238.18 318.79 239.38 318.79 239.38 316.72 238.18 316.72 238.18 314.11 242.59 314.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "251.54 317.98 246.47 317.98 245 317.98 242.28 317.98 242.28 320.13 237.69 320.13 237.69 323.23 246.47 323.23 246.47 321.74 246.47 321.32 251.54 321.32 251.54 317.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "221.99 301.48 221.99 300.92 221.99 300.12 221.99 298.68 218.79 298.68 218.79 300.36 216.51 300.36 216.51 298.03 214.35 298.03 214.35 295.94 210.33 295.94 210.33 299.13 212.57 299.13 212.57 300.43 206.23 300.43 206.23 303.61 209.24 303.61 209.24 306 216.51 306 216.51 303.61 216.51 302.81 216.51 302.6 219.74 302.6 219.74 303.79 221.3 303.79 221.99 303.79 224.34 303.79 224.34 301.48 221.99 301.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M366.06,282.82l-27.72,1.31,7,5.9h0a170.75,170.75,0,0,1-31.69,15.23c-19.3,6.87-36.21,10.34-50.48,10.34l-1.85,0a74.28,74.28,0,0,1-9-.72l.06,2.26h3.07v4.42h-3l.09,3.11a86.5,86.5,0,0,0,9.48.71l2.07,0c14.26,0,30.26-2.5,48.48-8.31a222.48,222.48,0,0,0,35.42-15l7.16-3.74,6.43,5.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "384.74 260.49 389.04 260.49 389.04 259.78 392.31 259.78 392.31 261.51 395.3 261.51 395.3 256.76 394.88 256.76 394.88 256.05 391.9 256.05 391.9 256.76 388.6 256.76 388.6 257.83 384.74 257.83 384.74 260.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 384.84,
    y: 267.18,
    width: 2.99,
    height: 2.99
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "389.27 269.63 392.25 269.63 392.25 267.36 394.6 267.36 394.6 265.23 390.88 265.23 390.88 266.65 389.27 266.65 389.27 269.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "398.71 255.97 398.71 258.46 402.64 258.46 402.64 257.44 402.64 255.97 402.64 255.71 405.21 255.71 405.21 253.22 402.47 253.22 402.47 250.75 399.43 250.75 399.43 253.8 400.46 253.8 400.46 255.97 398.71 255.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "403.18 241.21 404.83 241.21 406.02 241.21 406.35 241.21 406.35 243.42 405.36 243.42 405.36 245.19 407.29 245.19 410.66 245.19 413.23 245.19 413.23 242.15 408.33 242.15 408.33 237.32 407.67 237.32 406.35 237.32 404.83 237.32 404.83 238.98 403.18 238.98 403.18 241.21"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 398.89,
    y: 240.65,
    width: 2.87,
    height: 2.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 411.58,
    y: 231.65,
    width: 3.03,
    height: 3.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "407.15 227.69 409 227.69 410.18 227.69 412.03 227.69 412.03 223.03 409 223.03 409 224.75 407.15 224.75 407.15 227.69"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 416.66,
    y: 227.25,
    width: 4.62,
    height: 4.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "421.48 215.26 421.48 218.19 424.56 218.19 424.56 213.57 422.65 213.57 422.65 211.36 419.56 211.36 419.56 215.26 421.48 215.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 416.1,
    y: 194.85,
    width: 3.08,
    height: 4.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "419.03 192.24 419.03 194.59 422.11 194.59 422.11 189.9 420.08 189.9 419.03 189.9 417 189.9 417 192.24 419.03 192.24"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 416.72,
    y: 222,
    width: 2.88,
    height: 2.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 412.07,
    y: 207,
    width: 4.48,
    height: 2.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 411.25,
    y: 187.17,
    width: 4.05,
    height: 5.51
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "419.17 205.94 422.35 205.94 422.35 203.97 426.29 203.97 426.29 198.47 421.91 198.47 421.91 200.43 419.17 200.43 419.17 205.94"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 413.91,
    y: 216.31,
    width: 3.06,
    height: 4.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "420.94 186.29 420.94 188.91 425.12 188.91 425.12 184.73 422.01 184.73 422.01 182.57 418.18 182.57 418.18 180.07 415 180.07 415 182.57 415 183.78 415 186.29 420.94 186.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "397.74 161.59 397.74 164.12 397.74 165.67 400.55 165.67 400.55 165.73 400.55 166.78 400.55 168.03 404.79 168.03 404.79 165.73 403.57 165.73 403.57 160.56 401.49 160.56 400.68 160.56 400.68 159 400.02 159 397.74 159 394.45 159 394.45 161.59 397.74 161.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "380.8 161.8 380.8 166.72 386.96 166.72 386.96 165.06 392.79 165.06 392.79 157.12 391.6 157.12 385.22 157.12 384.02 157.12 384.02 159.19 385.22 159.19 385.22 161.8 380.8 161.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "371.85 157.93 376.92 157.93 378.4 157.93 381.12 157.93 381.12 155.79 385.7 155.79 385.7 152.68 376.92 152.68 376.92 154.18 376.92 154.59 371.85 154.59 371.85 157.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "401.41 174.43 401.41 174.99 401.41 175.79 401.41 177.23 404.61 177.23 404.61 175.55 406.89 175.55 406.89 177.88 409.04 177.88 409.04 179.97 413.06 179.97 413.06 176.78 410.82 176.78 410.82 175.49 417.17 175.49 417.17 172.3 414.15 172.3 414.15 169.91 406.89 169.91 406.89 172.3 406.89 173.1 406.89 173.31 403.66 173.31 403.66 172.12 402.1 172.12 401.41 172.12 399.06 172.12 399.06 174.43 401.41 174.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M257.34,193.09l27.72-1.31-7-5.9h0a171.36,171.36,0,0,1,31.69-15.23c19.3-6.87,36.22-10.34,50.48-10.34l1.86,0a74.28,74.28,0,0,1,9,.72l-.06-2.26h-3.08v-4.42h3l-.09-3.11a86.5,86.5,0,0,0-9.48-.71l-2.07,0c-14.26,0-30.27,2.5-48.48,8.31a222.62,222.62,0,0,0-35.42,15l-7.17,3.74-6.42-5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M315.18,280.17l.27-.16.48-1.67s.36-1.44.9-1.68,3.82-1.31,3.82-1.31c1.07-1.44-.18-2-.18-2a.91.91,0,0,1-1.13-.42c-.48-.72.47-1,1.13-1.68a1.46,1.46,0,0,0,.18-1.61l.9-.83s-1.62.3-1.44.06a5.19,5.19,0,0,0,.42-.84c-1.85,1.19-7.83,1.32-7.83,1.32a29.73,29.73,0,0,1-4-.6c-.3-.24-1.25.36-1.91.47a1.52,1.52,0,0,1-1.5-.77c-.36-.48.24-1,.24-1l-.71.42a8.9,8.9,0,0,1-1.74-.42,13.37,13.37,0,0,0-2.69,0l-1.85.3a5,5,0,0,1-.83-.72c-.24-.3-1.68-.89-2-1.19-.77-1.56-1.31-1.08-1.31-1.08-1.67.66-5.08-.18-5.08-.18-1.55-1.49-3.52-1.49-4.6-2.09s-3.95,1.56-3.95,1.56a24,24,0,0,1-2.74,1.31,9,9,0,0,1-2.21-.84l-.84-.89-.72-.72a15.78,15.78,0,0,1-1.07-1.37,12.76,12.76,0,0,0-1.08-1.26l-.36-.83a5.81,5.81,0,0,1-1,.11,6.26,6.26,0,0,1-1.62-.53,11.72,11.72,0,0,0-.17-1.8l-1.62-.89s.06-.54.06-.72,1.08,1,1.08,1l.77-.06s2.22-.18,2.63-.18A10.64,10.64,0,0,1,274,257.6s.36.36.72.66,2.09,0,2.09,0l1.68.84.23.53,1.56.72a3.79,3.79,0,0,1,1.49-.06c1.32.06,1.55-.12,1.68-.77s-1.5-.66-1.5-.66l-1.55-.24-2.33-1.26-.54-.59-1.14.18-1.73-1.14c-.83-.72-2.87-.12-2.87-.12l-1.43.12s-1.25.24-1.56.24a5.28,5.28,0,0,1-1.25-.54l-.54-.48-.77-.17-1.44-1.2-.3-.6-1.07-.3a3.32,3.32,0,0,1-.54-.89c-.18-.48.66-1.2.66-1.2.18-1.13,4.66-.77,5.43-.71s.42,1.19.72,1.79a2.9,2.9,0,0,0,1.68,1.07c.41.12,1.25-.54,1.25-.54l-1.14-.23s-1.25-.42-1.37-1.26-.12-.78,1.08-.83,1.61-1.5,1.61-1.5c-.42-1.49,1.49-1.49,1.49-1.91a6.44,6.44,0,0,1,.9-1.73l1-1.5a1.92,1.92,0,0,0,2.34-1.37c.11-.24,1.55-.78,1.55-.78s.83.84,1.43.18a.84.84,0,0,0,.06-1.2,2.66,2.66,0,0,1-2.57-1.37c-.65-.72,1.44-2.21,1.86-2.15s3-.3,3.1.12,1,1,1,1,.3-.18.42.53,1.85.3,1.85.3l.66-.83-1.08-.84a3.29,3.29,0,0,0-.84-1.32,2.22,2.22,0,0,1-1.91-.53l-.18-.84-1.31-.48s-.54-.12-.36-.36,0-1.37-.18-1.37-1.55.12-1.55.12l-.42-.3c-.78.18-2.45-.84-2.45-.84l-.06-.35c.72-.66,1.07-2.87,1.07-2.87a11.9,11.9,0,0,1,1.2-1.14,17.06,17.06,0,0,0,1.49-1.49l-.35-.84c1.31.48,1.55-.54,1.55-.54l-1.08-.83a37.52,37.52,0,0,1-3.52-2.09c-.72-.6-.24-1.68-.24-1.68s1-1,1.49-1.43a7.44,7.44,0,0,1,1.14-.78l1.19,1.43a1,1,0,0,0,1.14.19,3.77,3.77,0,0,1,3.11,2,5.66,5.66,0,0,1,0,3.28l1.07,1.86.48-.06,1.13,1.67,1.2-.42.78.12a.92.92,0,0,0,.77,1.14.8.8,0,0,0,1.08-.72s-.48-.66-.06-1.14,0-1.31,0-1.31l-.48-1.2s.3-.95.6-.95.89-.6.89-.6l.9-.6.06-.95c2.39,1.61,1.43-1.14,1.43-1.14l2.21-.24.78-1.25-.9-1.73a2.52,2.52,0,0,1-.89-.6,9.91,9.91,0,0,1-1-2.87l-.89-.54-1,.72-.84.06-.12.24-.59.12-1.14-.6-1.19,1s-3.47,1.61-4.66,2.32-4.6-1.37-4.6-1.37a3,3,0,0,0-2.27-.48,1.43,1.43,0,0,0-.9,2,1.18,1.18,0,0,1-.42,1.19s-.18.6-1.13.6-.66,1-.66,1l.18,1.44-1,.89-.3.84a24.48,24.48,0,0,1-2.57.78,9.71,9.71,0,0,1-2.09-.06,1.94,1.94,0,0,0-1.31-.48c-.72.06-.78-.48-.78-.48a2.63,2.63,0,0,0-.24-1.19c-.3-.78,1.2-1.56,1.74-1.44s1.25-.6,1-1.49.84-.72.84-.72l.77-.6-1.85-.77a8.82,8.82,0,0,1-2.45,1.49c-1,.24-.66-.78-1-1.19s.24-1.2.24-1.2l1.8-1.55-.33-.27c-.09-1,3.58-4,3.58-4a7.4,7.4,0,0,0-5.29,2.57c-9.06,11.08-12.91,25-9.19,38.36,0,0,2.56,11.24,18.34,15.24,0,0,1.61.9,2.39.66a6.13,6.13,0,0,0,1.61.42c1,.12.78,1.19,1.26,1.67s.12,1.55.12,1.55.29,1.38,1,1.5a.94.94,0,0,1,.78.83l.89.36a3.26,3.26,0,0,0,1.14,1c.6.24,2.21.65,2.21.65s1.14-.05,1.14.42,1.61.84,1.79.84l1.19-.06s2.33.42,2.57.9a2.55,2.55,0,0,0,1,.83l3.7,1.08a7.94,7.94,0,0,0,.9.48,12.25,12.25,0,0,0,3.05.65,4,4,0,0,0,3,.78s2.09,1.37,2.87,1.2a2.88,2.88,0,0,1,2,.3c.6.29,1.74-.3,1.74-.3l2-.12s1-.94,1.28-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M363.91,226.68c-6.81-24.42-35.43-37.77-63.91-29.82a13.77,13.77,0,0,0,3.44.75l-.84.6a58,58,0,0,0,6.58-.84l2.51.72,1.79,1,4.3.47a7.33,7.33,0,0,0,3.35,7.41l-8,1L313,209.8l.36,1a2.25,2.25,0,0,1,2,2.15,10.36,10.36,0,0,1-.12,2.27l.24,1.08,4.42.71s-.12-.48.84-.71,1-2.63.24-3.23a5.29,5.29,0,0,0-2-.84l-.72-1.19,1.67-1,3.47,1.44s3.94,1.43,1.07,5.61l-2,1.2-.36,1.55-.48,2.51-1.43,1s-2.75-1.08-3-1.8S315,221,315,221l.48.6s3.23,1.08,2.87,3.11l-1.2.36-.52.05-1.75.19.6.59,1.56-.35,2-.36s5.49-.12,4.78,2.15S322,230,322,230s-1.2.84-.6,1.79A4.86,4.86,0,0,0,325,233.7s0-1.55,1.79-1.31l-.35.84,1.55.83a3.72,3.72,0,0,0-.72,1.79c0,.84.48,2-.59,3.11l.71,1.55s-2.51.6-2.15,2.16l.36,1.55-.72,1.67a6.1,6.1,0,0,1,1.67,3.35L329,250l-.35.84,1.67.48,1,.84.83-1,2.51.24.84,1.19,2.39.48.48-1.19,1.91-1.08,1.67.84,2.15-2.27,2.75-.84.36-1.79,1.55-.84,2.15,1s.36-2.39,1.56-2.15,2-.12,2,3.82l3.82.36,1,2.27,1,.24-.36,2.51-1,1.43,1.2,1.32-.48,1s3.22.84,4.78-1.43c0,0,5.26-7.65-.48-29.49Zm-17.21-5.05-2.39,1.44v1.43s-3.1,1.67-3.46,1.55-2.15,1.56-2.15,1.56l-2.87-1.08-.84,1.56-1.19.71c-.6-.47-.72,1-.72,1L330.57,231l-2.15-.71s-.36-.72-1.2-2.63,1.79-3.35,1.79-3.35l1.2-1.07c1.55-.72.48-1.2.48-1.2.71-2.15,2.51-1.43,3.7-1.43a12.08,12.08,0,0,0,3-.6l1.08-2,3.22.12.84-1,3.35-.48,1.31,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M301.41,221.39l2.87-.83-.24.71s.95.36,0,.84-1.31.72-2.63-.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "305 206.1 303.32 207.53 305.95 208.01 307.03 206.46 304.75 207.17 305 206.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "176.91 355.68 182.52 355.68 182.52 383.19 200.18 383.19 200.18 387.31 176.91 387.31 176.91 355.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M228.65,355.22q9.09,0,15.13,4.65t6.05,11.64q0,7-6.1,11.58t-15.39,4.59q-8.86,0-14.77-4.59a14,14,0,0,1-5.91-11.49,14.29,14.29,0,0,1,6-11.73q6-4.65,15-4.65Zm.22,4.31a17.42,17.42,0,0,0-11.06,3.39,10.56,10.56,0,0,0-4.33,8.68,10.37,10.37,0,0,0,4.34,8.51,19.08,19.08,0,0,0,21.84-.07,10.58,10.58,0,0,0,4.39-8.63,10.38,10.38,0,0,0-4.39-8.45,17,17,0,0,0-10.79-3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M282.24,371.73h13.17v13.41A43.32,43.32,0,0,1,281,387.68q-9.73,0-15.56-4.59t-5.83-11.31a14.39,14.39,0,0,1,6-11.8q6-4.71,15.13-4.71a32.62,32.62,0,0,1,6.29.58,60.42,60.42,0,0,1,7.52,2.11v4.62a32.63,32.63,0,0,0-13.92-3.28,16.81,16.81,0,0,0-10.84,3.53,10.88,10.88,0,0,0,0,17.49q4.41,3.4,11.34,3.41a32.15,32.15,0,0,0,8.06-1.24l.53-.14v-6.59h-7.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 307.97,
    y: 355.68,
    width: 5.61,
    height: 31.64
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "357.76 355.68 363.09 355.68 363.09 387.31 358.26 387.31 332.05 362.95 332.05 387.31 326.77 387.31 326.77 355.68 331.31 355.68 357.76 380.25 357.76 355.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "375.8 355.68 398.03 355.68 398.03 359.71 381.41 359.71 381.41 369.35 397.47 369.35 397.47 373.41 381.41 373.41 381.41 383.24 398.56 383.24 398.56 387.27 375.8 387.27 375.8 355.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "440.04 355.68 445.29 355.68 445.29 387.31 439.65 387.31 439.65 362.69 427.59 374.93 426.55 374.93 414.36 362.69 414.36 387.31 408.74 387.31 408.74 355.68 414.06 355.68 427.09 368.67 440.04 355.68"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarro);
export default __webpack_public_path__ + "static/media/carro.592b567fcde70fc4c396117120b92471.svg";
export { ForwardRef as ReactComponent };